import { GeoLang } from '@repo/ui/src/types';
import _geoLangs from '../../utils/geoLangs.json';

const geoLangs: Array<GeoLang> = _geoLangs;

export { geoLangs };
